/* Quick buy for blank apparel, matching the blanks storefront on sell.dtftransfers.com.
 *
 * Why this is custom rather than the theme's own quick-buy: the theme renders its variant
 * picker INLINE in the card. Both routes (the quick_buy block and the deferred mode) grew the
 * card from 349px to 657px and left "Choose a variant first" sitting in the grid. Blanks need
 * the opposite shape, a bar on the card that opens a modal, because a blank has up to 70
 * colours and 8 sizes and the shopper usually wants several sizes of ONE colour in one go.
 *
 * Data comes from /products/<handle>.js on open, so the grid pays nothing until a shopper asks
 * for it. Swatches are painted from window.NT_BLANK_COLORS (assets/blanks-swatch-colors.js),
 * the same table the PDP and the cards use, because Collective carries no swatch metafields.
 *
 * Adding to cart posts every size with a quantity in one /cart/add.js call, then calls
 * window.refreshCart(), which is the theme's documented hook for apps (component-cart.js).
 *
 * Reused by the "Complete your order with Blanks" carousel: any element carrying
 * data-bqb-handle gets a button, so the carousel only has to render that attribute.
 */
(function () {
  'use strict';
  if (window.__blanksQuickBuy) return;
  window.__blanksQuickBuy = true;

  var VENDOR_CARD = '.product-item';
  var cache = {};
  var modal = null;
  var state = { product: null, color: null, colorIdx: -1, sizeIdx: -1 };

  function money(cents) {
    return '$' + (Math.round(cents) / 100).toFixed(2);
  }

  function hexFor(name) {
    var map = window.NT_BLANK_COLORS;
    if (!map) return null;
    var n = String(name || '').trim().toUpperCase().replace(/\s+/g, ' ');
    if (map[n]) return map[n];
    var alt = n.indexOf('GRAY') > -1 ? n.replace(/GRAY/g, 'GREY')
            : (n.indexOf('GREY') > -1 ? n.replace(/GREY/g, 'GRAY') : null);
    return alt && map[alt] ? map[alt] : null;
  }

  /* /products/x.js returns options as objects on newer stores and plain strings on older ones */
  function optionNames(p) {
    return (p.options || []).map(function (o) {
      return String((o && o.name) || o || '').toLowerCase();
    });
  }

  function indexOfOption(names, re) {
    for (var i = 0; i < names.length; i++) if (re.test(names[i])) return i;
    return -1;
  }

  function variantOption(v, idx) {
    return idx < 0 ? null : v['option' + (idx + 1)];
  }

  /* ── modal shell ──────────────────────────────────────────────────────── */

  function ensureModal() {
    if (modal) return modal;
    modal = document.createElement('div');
    modal.className = 'bqb';
    modal.setAttribute('hidden', '');
    modal.innerHTML =
      '<div class="bqb__scrim" data-bqb-close></div>' +
      '<div class="bqb__panel" role="dialog" aria-modal="true" aria-label="Quick buy">' +
        '<button class="bqb__x" type="button" data-bqb-close aria-label="Close">&times;</button>' +
        '<div class="bqb__media"><img class="bqb__img" alt=""></div>' +
        '<div class="bqb__body">' +
          '<h2 class="bqb__title"></h2>' +
          '<a class="bqb__full" href="#" target="_blank" rel="noopener">View full details</a>' +
          '<div class="bqb__pricewrap"><span class="bqb__aslow">As low as</span>' +
            '<span class="bqb__priceline"><span class="bqb__price"></span><span class="bqb__pricewas"></span></span></div>' +
          '<div class="bqb__colorhead"><span class="bqb__clabel">Color:</span>' +
            '<span class="bqb__cpick">' +
              '<button class="bqb__ctrigger" type="button" aria-haspopup="listbox" aria-expanded="false">' +
                '<span class="bqb__cchip"></span><span class="bqb__cname"></span>' +
                '<svg class="bqb__cchev" viewBox="0 0 24 24" width="16" height="16" fill="none"' +
                ' stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"' +
                ' aria-hidden="true"><path d="m6 9 6 6 6-6"/></svg>' +
              '</button>' +
              '<div class="bqb__clist" role="listbox" hidden></div>' +
            '</span>' +
            '<span class="bqb__ccount"></span></div>' +
          '<div class="bqb__swatches"></div>' +
          '<div class="bqb__sizehead">Choose size(s)</div>' +
          '<div class="bqb__buy">' +
            '<div class="bqb__sizes"></div>' +
            '<p class="bqb__note"></p>' +
            '<button class="bqb__add" type="button">Add to cart</button>' +
          '</div>' +
        '</div>' +
      '</div>';
    document.body.appendChild(modal);

    modal.addEventListener('click', function (e) {
      if (e.target.closest('[data-bqb-close]')) close();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' || modal.hasAttribute('hidden')) return;
      var list = modal.querySelector('.bqb__clist');
      if (list && !list.hasAttribute('hidden')) toggleList(false); else close();
    });
    modal.querySelector('.bqb__ctrigger').addEventListener('click', function (e) {
      e.stopPropagation();
      toggleList();
    });
    modal.querySelector('.bqb__clist').addEventListener('click', function (e) {
      var row = e.target.closest('[data-bqb-color]');
      if (!row) return;
      selectColor(row.getAttribute('data-bqb-color'));
      toggleList(false);
    });
    modal.addEventListener('click', function (e) {
      if (!e.target.closest('.bqb__cpick')) toggleList(false);
    });
    modal.querySelector('.bqb__swatches').addEventListener('click', function (e) {
      var b = e.target.closest('[data-bqb-color]');
      if (b) selectColor(b.getAttribute('data-bqb-color'));
    });
    /* Hovering (or tabbing onto) a swatch previews its name and chip in the colour dropdown;
       leaving the row puts the chosen colour back. Nothing else changes until a click.
       (Justin 2026-09-23) */
    var swRow = modal.querySelector('.bqb__swatches');
    function swPreview(e) {
      var b = e.target.closest && e.target.closest('[data-bqb-color]');
      if (b) showColorName(b.getAttribute('data-bqb-color'));
    }
    swRow.addEventListener('mouseover', swPreview);
    swRow.addEventListener('focusin', swPreview);
    swRow.addEventListener('mouseleave', function () { showColorName(state.color); });
    swRow.addEventListener('focusout', function (e) {
      if (!swRow.contains(e.relatedTarget)) showColorName(state.color);
    });
    /* Quantity boxes start at 0, so a click should replace that rather than append to it and
       leave someone ordering 01 shirts. Select on focus AND on click, because clicking an
       already-focused input does not re-fire focus. (Justin 2026-09-21) */
    function selectQty(e) {
      var q = e.target.closest && e.target.closest('.bqb__qty');
      if (q) { try { q.select(); } catch (err) {} }
    }
    modal.addEventListener('focusin', selectQty);
    modal.addEventListener('click', selectQty);
    modal.addEventListener('input', function (e) {
      if (e.target.classList && e.target.classList.contains('bqb__qty')) refreshAdd();
    });
    modal.addEventListener('click', function (e) {
      var step = e.target.closest('[data-bqb-step]');
      if (!step) return;
      var input = step.closest('.bqb__qtywrap').querySelector('.bqb__qty');
      if (!input || input.disabled) return;
      var q = parseInt(String(input.value).replace(/[^0-9]/g, ''), 10) || 0;
      q = step.getAttribute('data-bqb-step') === 'up' ? q + 1 : Math.max(0, q - 1);
      input.value = q ? String(q) : '';
      refreshAdd();
    });

    modal.querySelector('.bqb__add').addEventListener('click', addToCart);
    return modal;
  }

  function toggleList(force) {
    var m = ensureModal();
    var list = m.querySelector('.bqb__clist');
    var trig = m.querySelector('.bqb__ctrigger');
    var show = typeof force === 'boolean' ? force : list.hasAttribute('hidden');
    if (show) {
      list.removeAttribute('hidden');
      var on = list.querySelector('.bqb__crow.is-on');
      if (on) on.scrollIntoView({ block: 'nearest' });
    } else {
      list.setAttribute('hidden', '');
    }
    trig.setAttribute('aria-expanded', show ? 'true' : 'false');
  }

  function open() {
    ensureModal().removeAttribute('hidden');
    document.documentElement.classList.add('bqb-open');
  }

  function close() {
    if (modal) modal.setAttribute('hidden', '');
    document.documentElement.classList.remove('bqb-open');
  }

  /* ── rendering ────────────────────────────────────────────────────────── */

  /* Colours that can actually be bought: at least one size available. A colour sold out in
     every size used to render as a swatch, open to a row of "Sold out" boxes and a live Add to
     cart button. If a product somehow has no available variant at all, every colour is returned
     rather than an empty picker. (Justin 2026-09-23) */
  function colorsOf(p) {
    var seen = {}, all = [], live = {};
    for (var i = 0; i < p.variants.length; i++) {
      var v = p.variants[i];
      var c = variantOption(v, state.colorIdx);
      if (!c) continue;
      if (!seen[c]) { seen[c] = 1; all.push(c); }
      if (v.available) live[c] = 1;
    }
    var out = all.filter(function (c) { return live[c]; });
    return out.length ? out : all;
  }

  function render(p, wantColor) {
    var names = optionNames(p);
    state.product = p;
    state.colorIdx = indexOfOption(names, /colou?r/);
    state.sizeIdx = indexOfOption(names, /size/);

    var m = ensureModal();
    m.querySelector('.bqb__title').textContent = p.title;
    m.querySelector('.bqb__full').setAttribute('href', '/products/' + p.handle);

    var prices = p.variants.filter(function (v) { return v.available; }).map(function (v) { return v.price; });
    if (!prices.length) prices = p.variants.map(function (v) { return v.price; });
    var low = Math.min.apply(null, prices);
    m.querySelector('.bqb__price').textContent = money(low);
    /* the crossed-out price beside it, so every product shows one, one-size styles included
       (their size box carries no price): the same x 1.96 as the size boxes, or a real
       compare-at price when higher (Justin 2026-09-23) */
    var lowWas = Math.round(low * 1.96);
    p.variants.forEach(function (v) { if (v.price === low && v.compare_at_price > lowWas) lowWas = v.compare_at_price; });
    m.querySelector('.bqb__pricewas').textContent = money(lowWas);

    /* Set the fallback photo here, not at the end. selectColor swaps in the chosen colour's
       variant photo, and running this afterwards painted the product default straight back over
       it, so the modal always opened on the white shirt no matter which chip was clicked.
       (Justin 2026-09-22) */
    var img = m.querySelector('.bqb__img');
    img.src = (p.featured_image || '') || '';
    img.alt = p.title;

    var colors = state.colorIdx > -1 ? colorsOf(p) : [];
    var list = m.querySelector('.bqb__clist');
    var swatches = m.querySelector('.bqb__swatches');
    list.innerHTML = '';
    swatches.innerHTML = '';

    if (colors.length) {
      m.querySelector('.bqb__colorhead').style.display = '';
      m.querySelector('.bqb__ccount').textContent = colors.length + (colors.length === 1 ? ' color' : ' colors');
      colors.forEach(function (c) {
        var hexRow = hexFor(c);
        var row = document.createElement('button');
        row.type = 'button';
        row.className = 'bqb__crow';
        row.setAttribute('role', 'option');
        row.setAttribute('data-bqb-color', c);
        row.innerHTML = '<span class="bqb__lchip"' +
          (hexRow ? ' style="background-color:' + hexRow + '"' : ' data-unknown="1"') +
          '></span><span class="bqb__lname"></span>';
        row.querySelector('.bqb__lname').textContent = c;
        list.appendChild(row);

        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'bqb__sw';
        b.setAttribute('data-bqb-color', c);
        b.setAttribute('title', c);
        b.setAttribute('aria-label', c);
        var hex = hexFor(c);
        if (hex) b.style.backgroundColor = hex;
        else b.classList.add('bqb__sw--unknown');
        swatches.appendChild(b);
      });
      /* land on the colour the shopper clicked on the card, not always the first */
      var want = null;
      if (wantColor) {
        var w = String(wantColor).toLowerCase();
        for (var ci = 0; ci < colors.length; ci++) {
          if (String(colors[ci]).toLowerCase() === w) { want = colors[ci]; break; }
        }
      }
      selectColor(want || colors[0]);
    } else {
      m.querySelector('.bqb__colorhead').style.display = 'none';
      selectColor(null);
    }
  }

  /* The size a shopper reads: the supplier's "Adjustable" / "OS" (and Shopify's "Default Title")
     read "One Size", as snippets/size-label.liquid does for Liquid-built labels. Pack sizes such as
     "OS PK 5" pass through. (Justin 2026-09-24) */
  var ONE_SIZE = /^(adjustable|adj\.?|os|osfa|one-?size|one size fits (all|most)|default title)$/i;
  function sizeLabel(s) {
    s = String(s == null ? '' : s).trim();
    return ONE_SIZE.test(s) ? 'One Size' : s;
  }

  /* the dropdown's name and chip, for the chosen colour or one being hovered */
  function showColorName(color) {
    var m = ensureModal();
    var nameEl = m.querySelector('.bqb__cname');
    if (nameEl) nameEl.textContent = color || '';
    var chip = m.querySelector('.bqb__cchip');
    if (chip) {
      var chex = hexFor(color);
      chip.style.backgroundColor = chex || '';
      chip.classList.toggle('bqb__cchip--unknown', !chex);
    }
  }

  function selectColor(color) {
    state.color = color;
    var m = ensureModal();
    var p = state.product;
    if (!p) return;

    showColorName(color);
    var rows = m.querySelectorAll('.bqb__crow');
    for (var r = 0; r < rows.length; r++) {
      rows[r].classList.toggle('is-on', rows[r].getAttribute('data-bqb-color') === color);
    }
    var sw = m.querySelectorAll('.bqb__sw');
    for (var i = 0; i < sw.length; i++) {
      sw[i].classList.toggle('is-on', sw[i].getAttribute('data-bqb-color') === color);
    }

    var rows = p.variants.filter(function (v) {
      return state.colorIdx < 0 || variantOption(v, state.colorIdx) === color;
    });

    /* swap to the colour's own photo when the variant carries one */
    for (var j = 0; j < rows.length; j++) {
      if (rows[j].featured_image && rows[j].featured_image.src) {
        m.querySelector('.bqb__img').src = rows[j].featured_image.src;
        break;
      }
    }

    var wrap = m.querySelector('.bqb__sizes');
    wrap.innerHTML = '';
    rows.forEach(function (v) {
      var label = sizeLabel(state.sizeIdx > -1 ? variantOption(v, state.sizeIdx) : (v.title || 'One Size'));
      var cell = document.createElement('div');
      cell.className = 'bqb__size' + (v.available ? '' : ' is-out');
      /* crossed-out "retail" price, as the blank PDP shows it (snippets/blanks-size-cell.liquid):
         price x 1.96, Ninja's RETAIL_PRICE_MULTIPLIER, or a real compare-at price when higher;
         in-stock sizes only. Keep the factor in step with that snippet. (Justin 2026-09-23) */
      var was = Math.round(v.price * 1.96);
      if (v.compare_at_price && v.compare_at_price > was) was = v.compare_at_price;
      var compare = v.available ? '<span class="bqb__compare">' + money(was) + '</span>' : '';
      cell.innerHTML =
        '<span class="bqb__sizename">' + String(label) + '</span>' +
        '<span class="bqb__qtywrap">' +
          '<input class="bqb__qty" type="text" value="" inputmode="numeric" pattern="[0-9]*"' +
            ' aria-label="' + String(label) + ' quantity" data-bqb-id="' + v.id + '"' +
            ' data-bqb-price="' + v.price + '"' + (v.available ? '' : ' disabled') + '>' +
          '<span class="bqb__steps">' +
            '<button type="button" class="bqb__step" data-bqb-step="up" tabindex="-1" aria-hidden="true"></button>' +
            '<button type="button" class="bqb__step" data-bqb-step="down" tabindex="-1" aria-hidden="true"></button>' +
          '</span>' +
        '</span>' +
        /* price right under the box, the crossed-out price under that */
        '<span class="bqb__sizeprice">' + (v.available ? money(v.price) : 'Sold out') + '</span>' +
        compare;
      wrap.appendChild(cell);
    });

    /* A style that only comes in one size starts its box at 1 (and goes back to 1 after an add).
       It is laid out like two or three sizes: one box of full-row width, left, above the button.
       It used to sit beside the button; Justin moved it 2026-09-23. Keyed on the product's sizes
       rather than this colour's rows, so a multi-size style that happens to stock one size in
       this colour keeps its size label. (Justin 2026-09-23) */
    var sizes = {};
    if (state.sizeIdx > -1) p.variants.forEach(function (v) { sizes[variantOption(v, state.sizeIdx)] = 1; });
    var one = rows.length === 1 && Object.keys(sizes).length <= 1;
    state.single = one;
    /* three sizes or fewer keep full-row box widths, left-aligned, instead of stretching */
    m.classList.toggle('bqb--few', rows.length <= 3);
    if (one && rows[0].available) wrap.querySelector('.bqb__qty').value = '1';

    setNote('');
    refreshAdd();
  }

  /* Ninja's button carries the running count and total, so the shopper sees what they are
     committing to before they click. Recomputed on every quantity change. */
  function refreshAdd() {
    var m = ensureModal();
    var inputs = m.querySelectorAll('.bqb__qty');
    var n = 0, total = 0;
    for (var i = 0; i < inputs.length; i++) {
      var q = parseInt(String(inputs[i].value).replace(/[^0-9]/g, ''), 10);
      if (!(q > 0)) continue;
      n += q;
      total += q * (parseInt(inputs[i].getAttribute('data-bqb-price'), 10) || 0);
    }
    var btn = m.querySelector('.bqb__add');
    btn.textContent = n
      ? 'Add ' + n + (n === 1 ? ' item - ' : ' items - ') + money(total)
      : 'Add to cart';
    btn.classList.toggle('is-ready', n > 0);
  }

  function setNote(text, isError) {
    var n = ensureModal().querySelector('.bqb__note');
    n.textContent = text || '';
    n.classList.toggle('is-error', !!isError);
  }

  /* ── add to cart ──────────────────────────────────────────────────────── */

  function bumpCartCount() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (c) {
        if (!c) return;
        var els = document.querySelectorAll('[data-header-cart-count]');
        for (var i = 0; i < els.length; i++) {
          els[i].textContent = c.item_count;
          els[i].setAttribute('data-count', c.item_count);
        }
      })
      .catch(function () {});
  }

  function addToCart() {
    var m = ensureModal();
    var inputs = m.querySelectorAll('.bqb__qty');
    var items = [];
    for (var i = 0; i < inputs.length; i++) {
      var q = parseInt(String(inputs[i].value).replace(/[^0-9]/g, ''), 10);
      if (q > 0) items.push({ id: parseInt(inputs[i].getAttribute('data-bqb-id'), 10), quantity: q });
    }
    if (!items.length) { setNote('Choose a quantity for at least one size.', true); return; }

    var btn = m.querySelector('.bqb__add');
    btn.disabled = true;
    btn.textContent = 'Adding...';
    setNote('');

    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        btn.disabled = false;
        btn.textContent = 'Add to cart';
        if (!res.ok) {
          setNote((res.data && res.data.description) || 'That could not be added.', true);
          return;
        }
        var units = 0;
        for (var n = 0; n < items.length; n++) units += items[n].quantity;
        var name = state.product ? state.product.title : '';
        /* The modal stays open and the quantities reset, so a shopper can switch colour and add
           again without reopening it. The toast is the confirmation; closing on every add made
           buying two colours of the same style a four-click round trip. (Justin 2026-09-22) */
        var reset = state.single ? '1' : '';
        for (var qi = 0; qi < inputs.length; qi++) inputs[qi].value = inputs[qi].disabled ? '' : reset;
        refreshAdd();
        showToast('Added to cart', units + (units === 1 ? ' item, ' : ' items, ') + name);

        /* 'notOpen' refreshes the counts and totals without pulling the drawer out. A plain
           refreshCart() opens it, and on a builder that buries the artwork the shopper is
           working on. The old fallback here was location.reload(), which would have thrown
           away an in-progress upload outright; a quiet count update is enough. */
        var cartEl = document.getElementById('AjaxCartForm');
        if (typeof window.refreshCart === 'function' && cartEl) window.refreshCart('notOpen');
        else bumpCartCount();
      })
      .catch(function () {
        btn.disabled = false;
        btn.textContent = 'Add to cart';
        setNote('Something went wrong. Please try again.', true);
      });
  }

  /* ── colour preview on the card ───────────────────────────────────────── */
  /* A chip changes the photo on the card instead of opening anything, and the card remembers
     the choice in data-bqb-color so the Quick buy button and the photo open the modal already
     on that colour. (Justin 2026-09-22) */
  function cardImage(card) {
    return card.querySelector('.bur-card__img img, .product-item__image-figure img, img.img, .product-item__image img');
  }

  function markChip(card, color) {
    var chips = card.querySelectorAll('.bcu-sw[data-colorname]');
    for (var i = 0; i < chips.length; i++) {
      chips[i].classList.toggle('is-on', chips[i].getAttribute('data-colorname') === color);
    }
  }

  function previewColor(card, handle, color) {
    card.setAttribute('data-bqb-color', color);
    markChip(card, color);
    var img = cardImage(card);
    if (!img) return;

    function apply(p) {
      if (!p) return;
      var idx = indexOfOption(optionNames(p), /colou?r/);
      if (idx < 0) return;
      for (var i = 0; i < p.variants.length; i++) {
        var v = p.variants[i];
        if (variantOption(v, idx) === color && v.featured_image && v.featured_image.src) {
          /* the theme's responsive attributes would otherwise win over a plain src */
          img.removeAttribute('srcset');
          img.removeAttribute('data-srcset');
          img.src = v.featured_image.src;
          return;
        }
      }
    }

    if (cache[handle]) { apply(cache[handle]); return; }
    fetch('/products/' + handle + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) { if (p) { cache[handle] = p; apply(p); } })
      .catch(function () {});
  }

  /* ── added-to-cart toast ──────────────────────────────────────────────── */
  /* A shopper adding a blank from a builder is mid-order: pulling the cart drawer out covers
     the page they are working on and interrupts them. This confirms the add in the corner and
     leaves them where they were. It is published as window.showCartToast because the theme
     already calls a hook by that name (component-cart.js on narrow screens,
     apparel-product-child.liquid) and nothing ever defined it, so those add-to-carts were
     silent. (Justin 2026-09-22) */
  var toastWrap = null;

  function toastHost() {
    if (toastWrap && document.body.contains(toastWrap)) return toastWrap;
    toastWrap = document.createElement('div');
    toastWrap.className = 'bqb-toasts';
    document.body.appendChild(toastWrap);
    return toastWrap;
  }

  /* sit under the sticky header rather than over it, without hard-coding its height */
  function toastTop() {
    var hdr = document.querySelector('header.dtfhd, .dtfhd, header');
    if (!hdr) return 16;
    var r = hdr.getBoundingClientRect();
    if (!r.height) return 16;
    return Math.max(16, Math.min(r.bottom + 12, 160));
  }

  function showToast(title, detail) {
    var host = toastHost();
    host.style.top = toastTop() + 'px';

    var t = document.createElement('div');
    t.className = 'bqb-toast';
    t.setAttribute('role', 'status');
    t.innerHTML =
      '<svg class="bqb-toast__ok" viewBox="0 0 24 24" width="20" height="20" aria-hidden="true">' +
      '<circle cx="12" cy="12" r="11" fill="#1f9d55"></circle>' +
      '<path d="m7 12.4 3.2 3.2L17 8.8" fill="none" stroke="#fff" stroke-width="2.2"' +
      ' stroke-linecap="round" stroke-linejoin="round"></path></svg>' +
      '<span class="bqb-toast__body"><strong></strong><span class="bqb-toast__detail"></span></span>' +
      /* deliberately no cart link: the whole point of the toast is that the shopper is not taken
         off the page they uploaded artwork on (Justin 2026-09-22) */
      '<button class="bqb-toast__x" type="button" aria-label="Dismiss">' +
      '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor"' +
      ' stroke-width="2.4" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg></button>';
    t.querySelector('strong').textContent = title;
    t.querySelector('.bqb-toast__detail').textContent = detail || '';
    host.appendChild(t);

    var timer = null;
    function drop() {
      if (!t.parentNode) return;
      t.classList.add('is-going');
      setTimeout(function () { if (t.parentNode) t.parentNode.removeChild(t); }, 220);
    }
    function arm() { timer = setTimeout(drop, 4500); }
    t.addEventListener('mouseenter', function () { clearTimeout(timer); });
    t.addEventListener('mouseleave', arm);
    t.querySelector('.bqb-toast__x').addEventListener('click', function () {
      clearTimeout(timer);
      drop();
    });
    requestAnimationFrame(function () { t.classList.add('is-in'); });
    arm();
    return t;
  }

  if (typeof window.showCartToast !== 'function') {
    window.showCartToast = function (data) {
      var d = data || {};
      var title = d.product_title || d.title || '';
      showToast('Added to cart', title);
    };
  }

  /* ── opening ──────────────────────────────────────────────────────────── */

  function openFor(handle, color) {
    open();
    var m = ensureModal();
    m.querySelector('.bqb__title').textContent = 'Loading...';
    m.querySelector('.bqb__sizes').innerHTML = '';
    m.querySelector('.bqb__swatches').innerHTML = '';

    if (cache[handle]) { render(cache[handle], color); return; }
    fetch('/products/' + handle + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        if (!p) { setNote('Could not load this product.', true); return; }
        cache[handle] = p;
        render(p, color);
      })
      .catch(function () { setNote('Could not load this product.', true); });
  }

  /* ── buttons on the cards ─────────────────────────────────────────────── */

  function handleFromCard(card) {
    var explicit = card.getAttribute('data-bqb-handle');
    if (explicit) return explicit;
    var a = card.querySelector('a[href*="/products/"]');
    if (!a) return null;
    var m = (a.getAttribute('href') || '').match(/\/products\/([^/?#]+)/);
    return m ? m[1] : null;
  }

  function decorate(root) {
    var cards = (root || document).querySelectorAll(VENDOR_CARD + ':not([data-bqb-done]), [data-bqb-handle]:not([data-bqb-done])');
    for (var i = 0; i < cards.length; i++) {
      var card = cards[i];
      var handle = handleFromCard(card);
      /* not rendered yet: leave it unmarked so a later pass can decorate it. Marking first is
         why quick buy vanished from re-rendered grids after filtering. (Justin 2026-09-22) */
      if (!handle) continue;
      card.setAttribute('data-bqb-done', '1');
      var host = card.querySelector('.product-item__image') || card;
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'bqb-trigger';
      btn.setAttribute('data-bqb-open', handle);
      btn.innerHTML =
        '<svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" stroke-width="2"' +
        ' stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
        '<circle cx="9" cy="20" r="1.4"></circle><circle cx="18" cy="20" r="1.4"></circle>' +
        '<path d="M2 3h2.5l2.6 12.2a1.6 1.6 0 0 0 1.6 1.3h8.9a1.6 1.6 0 0 0 1.6-1.2L21.5 7H6"></path></svg>' +
        '<span>Quick buy</span>';
      if (getComputedStyle(host).position === 'static') host.style.position = 'relative';
      host.appendChild(btn);
    }
  }

  /* Click routing:
       - a colour chip previews that colour on the card and changes nothing else
       - the "+N" chip opens the modal, which is where every colour lives
       - the Quick buy button opens the modal on whatever colour the card is showing
       - anywhere on a card marked data-bqb-only does the same
     data-bqb-only is what the upsell row on the builders sets. A shopper there is mid-upload,
     and sending them to a PDP drops the artwork they just uploaded, so those cards never
     navigate. Collection cards keep their links on the photo and title.
     (Justin 2026-09-22) */
  function shownColor(card) {
    return (card && card.getAttribute('data-bqb-color')) || null;
  }

  document.addEventListener('click', function (e) {
    var el = e.target;
    if (!el || !el.closest) return;

    var t = el.closest('[data-bqb-open]');
    if (t) {
      e.preventDefault();
      e.stopPropagation();
      var host = t.closest('[data-bqb-handle], ' + VENDOR_CARD);
      openFor(t.getAttribute('data-bqb-open'), shownColor(host));
      return;
    }

    var card = el.closest('[data-bqb-handle], ' + VENDOR_CARD);
    if (!card) return;
    var handle = handleFromCard(card);
    if (!handle) return;

    var chip = el.closest('.bcu-sw[data-colorname]');
    if (chip) {
      e.preventDefault();
      e.stopPropagation();
      previewColor(card, handle, chip.getAttribute('data-colorname'));
      return;
    }

    if (el.closest('.bcu-sw-more')) {
      e.preventDefault();
      e.stopPropagation();
      openFor(handle, shownColor(card));
      return;
    }

    if (card.hasAttribute('data-bqb-only')) {
      e.preventDefault();
      e.stopPropagation();
      openFor(handle, shownColor(card));
    }
  });

  function start() {
    decorate();
    if ('MutationObserver' in window) {
      var pending = null;
      new MutationObserver(function () {
        if (pending) clearTimeout(pending);
        pending = setTimeout(function () { decorate(); }, 150);
      }).observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();

  window.NTBlanksQuickBuy = { open: openFor, decorate: decorate };
}());
